<template>
    <div
         ref="chatIconRef"
         class="chat-icon"
         @click.prevent="showChat()"
         v-pan="onPanChatIcon"
    >
        <img src="@/assets/icon-chat.svg">
        <div v-show="totalNewMessages > 0" class="chat-icon--badge">{{ totalNewMessages }}</div>
    </div>
</template>

<script>
import { SET_OPEN_CHAT } from '../constants/mutation-types'
import { appType } from '../constants/constants'
import { mapGetters } from 'vuex'

export default {
  name: 'ChatIcon',
  data () {
    return {
      currentOffsetX: 0,
      currentOffsetY: 0,
      lastTimePan: 0,
      isPan: false
    }
  },
  computed: {
    ...mapGetters({
        totalNewMessages: 'totalNewMessages',
        thread: 'currentThread'
    }),
    minHeight: function () {
      return window.innerHeight - this.$refs.chatIconRef.clientHeight - 10
    },
    maxHeight: function () {
      return 0
    },
    minWidth: function () {
      return window.innerWidth - 72
    },
    maxWidth: function () {
      return 5
    }
  },
  methods: {
    showChat: function () {
      const deltaTime = new Date().getTime() - this.lastTimePan
      if (!this.isPan || deltaTime < 100) {
        this.$store.commit(SET_OPEN_CHAT, !this.$store.state.isOpenChat)
        const { thread } = this
        if (this.$appType === appType.EDRIVER && thread.id) {
          this.$store.dispatch('readMessage', {
            roomId: thread.id
          })
        }
      }
      this.isPan = false
      this.lastTimePan = 0
    },
    onPanChatIcon: function (e) {
      e.preventDefault()
      if (!this.isPan) {
        this.lastTimePan = new Date().getTime()
        this.isPan = true
      }
      const direction = e.direction
      let dragXOffset = e.deltaX
      let dragYOffset = e.deltaY
      if (this.$refs.chatIconRef != null) {
        let transformX = this.currentOffsetX + dragXOffset
        let transformY = this.currentOffsetY + dragYOffset
        if (transformY < -this.minHeight) {
          transformY = -this.minHeight
        }
        if (transformY > this.maxHeight) {
          transformY = this.maxHeight
        }
        if (transformX < -this.minWidth) {
          transformX = -this.minWidth
        }
        if (transformX > this.maxWidth) {
          transformX = this.maxWidth
        }
        if (e.isFinal) {
          this.currentOffsetX = transformX
          this.currentOffsetY = transformY
          setTimeout(() => {
            this.isPan = false
          }, 100)
        }
        let value = [
          'translate3d(' + transformX + 'px, ' + transformY + 'px, 0)',
          'scale(' + 1 + ', ' + 1 + ')',
          'rotate3d('+ 0 +','+ 0 +','+ 0 +','+  0 + 'deg)'
        ];

        value = value.join(" ");
        this.$refs.chatIconRef.style.transform = value
      }
    },
  },
  watch: {
    'totalNewMessages': function (newValue, oldValue){
      if(typeof this.$callbackCountUnreadMessage=== 'function'){
        this.$callbackCountUnreadMessage(newValue, oldValue)
      }
    }
  }
}
</script>

<style lang="scss">
.chat-icon {
    position: fixed;
    bottom: 5px;
    right: 10px;
    width: 56px;
    height: 56px;
    cursor: pointer;
    img {
        width: 100%;
        height: 100%;
    }
    .chat-icon--badge {
        background-color: #db4437;
        color: #ffffff;
        border-radius: 5px;
        padding: 1px 2px;
        min-width: 15px;
        text-align: center;
        position: absolute;
        top: -10px;
        right: -5px;
        font-size: 13px;
    }
}
</style>
